import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const EmptyState = ({ type = 'no-projects' }) => {
  const navigate = useNavigate();

  const states = {
    'no-projects': {
      icon: 'FolderOpen',
      title: '목표가 없습니다',
      description: '첫 번째 챌린지 목표를 만들어 목표 달성을 시작하세요!',
      actionLabel: '목표 만들기',
      action: () => navigate('/project-creation')
    },
    'no-results': {
      icon: 'Search',
      title: '검색 결과가 없습니다',
      description: '다른 검색어나 필터를 시도해보세요.',
      actionLabel: '필터 초기화',
      action: null
    }
  };

  const state = states?.[type];

  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="w-20 h-20 md:w-24 md:h-24 bg-muted/50 rounded-full flex items-center justify-center mb-6">
        <Icon name={state?.icon} size={40} color="var(--color-muted-foreground)" />
      </div>
      <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-3 text-center">
        {state?.title}
      </h3>
      <p className="text-sm md:text-base text-muted-foreground caption text-center max-w-md mb-6">
        {state?.description}
      </p>
      {state?.action && (
        <Button
          variant="default"
          iconName="Plus"
          iconPosition="left"
          onClick={state?.action}
        >
          {state?.actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;